var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "--bgSolid --withBorder d-flex justify-content-between align-items-center"
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("img", {
              staticClass: "img-fluid header__logo",
              attrs: {
                src: "assets/img/adoptuj-kravicku-logo.svg",
                alt: "adoptuj-kravicku-logo"
              }
            })
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "skolske-menu" }, [
            _c(
              "li",
              { class: { active: _vm.$route.name === "skoly-dashboard" } },
              [
                _c("router-link", { attrs: { to: "/skoly" } }, [
                  _vm._v("\n                    Úvod\n                ")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { class: { active: _vm.$route.name === "skoly-ulohy" } },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "skoly-ulohy",
                        params: {
                          rocnik: _vm.profil.pouzivatel_id.pouzivatel_rocnik
                        }
                      }
                    }
                  },
                  [_vm._v("\n                    Naše úlohy\n                ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { class: { active: _vm.$route.name === "skoly-trieda" } },
              [
                _c("router-link", { attrs: { to: { name: "skoly-trieda" } } }, [
                  _vm._v("\n                    Naša trieda\n                ")
                ])
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.profil.pouzivatel_id
        ? _c("menu-user", {
            attrs: { profil: _vm.profil, "is-type-skoly": true }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }